import React from 'react';
import 'bootstrap-select';

const Disbursement: React.FC = () => {

  return (
    <div className="h-100">
      this is disbursement
    </div>
  );

};

export default Disbursement;